import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import {
  addPreviousTasksAndSubtasks,
  MetaDataAT,
  MetaDataElement,
  MetaDataET,
  PostFilteredItemDetailsTypes,
} from '../models/metaDataConfig';

export default class MetaDataStore {
  metaDataATRegistry = new Map<string, MetaDataAT>();
  metaDataETRegistry = new Map<string, MetaDataET>();
  selectedMetaDataAT: MetaDataAT | undefined = undefined;
  selectedMetaDataET: MetaDataET | undefined = undefined;
  selectedMetaDataElem: MetaDataElement = {
    elementValue: '',
    elementId: '',
    elementName: '',
    elementType: '',
    elementDateTime: '',
    creatorName: '',
    elementIndex: 0,
    isActive: false,
    isDeleted: false,
    options: [],
    enableByDefault: false,
    validation: '',
    files: [],
    photos: [],
    templateElementId: '',
    readOnly: false,
    parentMetadataID: [],
    metadatatype: '',
    parentId: '',
    isMandatory: false,
    selectMasterComponent: '',
    metadataFromParent: '',
  };
  loadingInitial = false;
  loadingInitialAT = false;
  loadingInitialET = false;
  loadingInitialElem = false;
  selectedMetaParentId: MetaDataElement | undefined = undefined;
  DropdownParentAll: string = '';
  updateSideComponentHeight: boolean = false;
  assetTypesDropdownList: { key: string; value: string; text: string }[] = [];
  elementTypeDropdownList: { key: string; value: string; text: string }[] = [];
  componentsDropdownList: { key: string; value: string; text: string }[] = [];
  NfaiRestorationDashboardInfo: {
    loading: boolean;
    data: any[],
    count: number,
  } ={
    loading: false,
    data: [],
    count: 0,
  }
  ltoLabelTitle: string = '';
  originalLTOs: string[] = [];
  cloneLTOs: string[] = [];
  masteringFileUpload:boolean = false;

  constructor() {
    makeAutoObservable(this);
  }
  private setmetaDataAT = (assetTypeDetails: MetaDataAT) => {
    this.metaDataATRegistry.set(assetTypeDetails.id, assetTypeDetails);
  };
  get metaDataATItems() {
    return Array.from(this.metaDataATRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };
  loadMetaDataAT = async () => {
    this.loadingInitial = true;
    this.loadingInitialAT = true;
    try {
      const assetTypeDetails =
        await agent.MetaDataAssetTypes.listMetaDataAssetTypes();
      assetTypeDetails.filter((x) => x.isDeleted === false);
      //sorting data
      assetTypeDetails.sort((a, b) => a.typeIndex - b.typeIndex);
      this.assetTypesDropdownList = assetTypeDetails.map(
        (d: { id: string; typeName: string }) => {
          return {
            key: d.id,
            value: d.typeName,
            text: d.typeName,
          };
        },
      );
      assetTypeDetails.forEach((assetTypeDetails) => {
        runInAction(() => {
          this.setmetaDataAT(assetTypeDetails);
        });
      });
      this.setLoadingInitial(false);
      this.loadingInitialAT = false;
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
        this.loadingInitialAT = false;
      });
    }
  };
  loadMetaDataATById = async (id: string) => {
    this.loadingInitial = true;
    this.loadingInitialET = true;
    try {
      const AssetType = await agent.MetaDataAssetTypes.getmetaDataAssetType(id);
      const fileteredData = AssetType.elementTypes.filter(
        (x: MetaDataET) => x.isDeleted === false,
      ); //filtering data
      const sortedAssetType = {
        ...AssetType,
        elementTypes: fileteredData.sort(
          (a, b) => a.elementTypeIndex - b.elementTypeIndex,
        ),
      };
      this.setmetaDataAT(AssetType);
      this.elementTypeDropdownList = sortedAssetType.elementTypes?.map(
        (d: { id: string; elementName: string }) => {
          return {
            key: d.id,
            value: d.elementName,
            text: d.elementName,
          };
        },
      );
      runInAction(() => {
        this.selectedMetaDataAT = sortedAssetType;
      });
      this.setLoadingInitial(false);
      this.loadingInitialET = false;
      return sortedAssetType;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadingInitialET = false;
    }
  };

  ////////////////////////////////////////////////////////////////  TypeElement
  loadMetaDataETById = async (id: string) => {
    if (id !== null && id !== undefined && id.length > 0) {
      try {
        this.loadingInitialElem = true;
        const elementTypes =
          await agent.MetaDataElementType.listMetaDataETDetails(id);
        const fileteredData = elementTypes.metadata.filter(
          (x: MetaDataElement) => x.isDeleted === false,
        ); //filtering data
        const sortedElementType = {
          ...elementTypes,
          metadata: fileteredData.sort(
            (a, b) => a.elementIndex - b.elementIndex,
          ),
        };
        this.componentsDropdownList = sortedElementType.metadata.map(
          (d: { elementName: string }) => {
            return {
              key: d.elementName,
              value: d.elementName,
              text: d.elementName,
            };
          },
        );
        // this.setElementTypes(AssetType);
        runInAction(() => {
          this.selectedMetaDataET = sortedElementType;
        });
        this.setLoadingInitial(false);
        this.loadingInitialElem = false;
        return sortedElementType;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
        this.loadingInitialElem = false;
      }
    } else {
      this.selectedMetaDataET = undefined;
    }
  };
  //create Element Types

  editMetaDataET = async (payload: any, elements: any) => {
    this.loadingInitial = true;
    try {
      let params = {
        startIndex: payload.startIndex,
        endIndex: payload.endIndex,
      };
      await agent.MetaDataElementType.reArrangeOrder(params, payload.elementId);

      runInAction(() => {
        // this.selectedMetaDataET=elementType;
        this.metaDataETRegistry.set(elements.id, elements);
      });
      toast.success('Element Type Edited Succesfully');
    } catch (error) {
      console.log(error);
    }
  };

  ///////////////////////////////////////////////////Meta Data Component
  loadMetaDataElemById = async (id: string) => {
    try {
      const metadataelem = await agent.MetaDataElements.elementDetails(id);
      runInAction(() => {
        this.selectedMetaDataElem = metadataelem;
      });
      this.setLoadingInitial(false);
      return metadataelem;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  editElements = async (elements: MetaDataElement) => {
    this.loadingInitial = true;
    try {
      await agent.MetaDataElements.editElement(elements);
      this.loadMetaDataAT();
      runInAction(() => {
        this.selectedMetaDataElem = elements;
      });
      toast.success('Element Edited  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      toast.error('Element Edited failed.');
      console.log(error);
    }
  };
  editSettingsElements = async (
    elements: MetaDataElement,
    // ,metaDataETArr:MetaDataET
  ) => {
    this.loadingInitial = true;
    try {
      await agent.MetaDataElements.editElement(elements);
      this.loadMetaDataAT();
      runInAction(() => {
        this.selectedMetaDataElem = elements;
        // this.selectedMetaDataET=metaDataETArr;
      });
      toast.success('Element Edited  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      toast.error('Element Edited failed.');
      console.log(error);
    }
  };
  createMetaDataTempUnderET = async (
    templateTask: MetaDataET,
    templateTaskFrontEnd: MetaDataET,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.MetaDataElements.createElemUnderET(templateTask);
      this.loadMetaDataAT();

      runInAction(() => {
        this.selectedMetaDataET = templateTaskFrontEnd;
      });
      toast.success('Template Updated Created Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
    }
  };
  deleteElements = async (element: MetaDataElement, metaDataET: MetaDataET) => {
    this.loadingInitial = true;
    try {
      await agent.MetaDataElements.deleteElement(element);
      this.loadMetaDataAT();
      runInAction(() => {
        this.selectedMetaDataET = metaDataET;
      });
      toast.success('Element Deleted Succesfully');
    } catch (error) {
      console.log(error);
    }
  };
  /////////////////////////////////////////////Options
  createOptionsUnderElements = async (
    singleElem: MetaDataElement,
    allOptionUnderElem: MetaDataElement,
    elemAndOptions: MetaDataElement,
    subtaskArr: MetaDataET,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.MetaDataElements.editElement(singleElem); //for edit single elem
      //    await agent.MetaDataOption.createOptionsUnderElements(allOptionUnderElem);//for Create elem under subtask
      this.loadMetaDataAT();
      runInAction(() => {
        this.selectedMetaDataElem = elemAndOptions;
        this.selectedMetaDataET = subtaskArr;
      });
      toast.success('Options Updated  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
    }
  };
  elementToggleOffEdit = async (elementId: string) => {
    try {
      await agent.MetaDataElements.elementToggleOffEditAPI(elementId);
      toast.success('Element Edited Succesfully.');
    } catch (error) {
      toast.error('Element Edited failed.');
      console.log(error);
    }
  };

  deleteOptions = async (id: string, componentName: string) => {
    this.loadingInitial = true;
    try {
      await agent.MetaDataOption.deleteOptionsAPI(id);
      if (componentName === 'DropDown')
        toast.success('Option Deleted Successfully.');
      else {
        toast.success('Column header deleted successfully.');
      }
      toast.success('Option Deleted Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      if (componentName === 'DropDown') toast.error('Option Deleted failed.');
      else {
        toast.success('Column header delete failed.');
      }

      console.log(error);
    }
  };
  dropDowndata = (data: string) => {
    this.DropdownParentAll = data;
  };
  WorkflowMetadataHandler = async (item: string) => {
    try {
      const metaDataDetails: any =
        await agent.ElementTypes.getElementTypeMetaDataTemplate(item);
      return metaDataDetails[0]?.metadata;
    } catch (error) {
      toast.error('MetaData List failed ...');
    }
  };
  CutlistMetadataSummary = async (itemId: string) => {
    try {
      const response = await agent.NFAI.CutlistreelAnalysisInformation(itemId);
      return response.data;
    } catch (error) {
      toast.error('Cutlist Summary Failed...');
    }
  };

  ColorGradingParameters = async (title:string) => {
    try {
      const Response = await agent.NFAI.ColorGradingcheckparameters(title);
      return Response.data;
    } catch (error) {
      console.log('ColorGradingParameters Failed...');
    }
  };
  DeliverablesParameters = async (id:string, subtaskId:string) => {
    try {
      const response = await agent.NFAI.getValueForDeliverables(id, subtaskId);
      return response.data;
    } catch (error) {
      console.log('DeliverablesQCReport failed...');
    }
  }
  LTOBarCodeValues = async (id: string) => {
    try {
      const response = await agent.NFAI.getLTOBarCode(id);
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        runInAction(() => {
          this.ltoLabelTitle = data[0].title;
          this.originalLTOs = data.map((item: any) => item.originaL_LTO);
          this.cloneLTOs = data.map((item: any) => item.clonE_LTO);
        });
      }
    } catch (error) {
      console.error('LTOBarcodeValues failed...', error);
    }
  };
  PostFilteredItemDetailsHandler = async (params:PostFilteredItemDetailsTypes) => {
    try {
      this.NfaiRestorationDashboardInfo.loading = true;
      const{ data } = await agent.NFAI.PostFilteredItemDetails(params);
      const { data:count } = await agent.NFAI.GetFilteredItemDetailscount(params);
      runInAction(() => {
        this.NfaiRestorationDashboardInfo.data = addPreviousTasksAndSubtasks(data);
        this.NfaiRestorationDashboardInfo.count = count;
        this.NfaiRestorationDashboardInfo.loading = false;
      })
    } catch (error) {
      this.NfaiRestorationDashboardInfo.loading = false;
      console.log('ColorGradingParameters Failed...');
    }
  };
}
